import Link from "ds/components/Link";
import { SpacesContext } from "views/Account/SpacesProvider";
import useTypedContext from "hooks/useTypedContext";

import { CellComponentProps } from "../types";
import useRoleUsedByAnalytics from "../useRoleUsedByAnalytics";

type RoleUsedByListItemSpaceCellProps = CellComponentProps;

const RoleUsedByListItemSpaceCell = ({ entity }: RoleUsedByListItemSpaceCellProps) => {
  const trackAnalytics = useRoleUsedByAnalytics();
  const { spaces } = useTypedContext(SpacesContext);
  const hasAccessToSpace = !!spaces.find(({ id }) => id === entity.space.id);

  return (
    <Link
      size="small"
      href={`/spaces/${entity.space.id}`}
      onPress={() => trackAnalytics("Space link clicked")}
      disabled={!hasAccessToSpace}
      tooltip={!hasAccessToSpace ? "You don't have access to this space" : undefined}
    >
      {entity.space.name}
    </Link>
  );
};

export default RoleUsedByListItemSpaceCell;
